/** Spanish bar-graph prompts and chart category vocabulary (ADR 0051 part 3). */
export const barGraphPrompts = {
    total: () => `¿Cuál es el total de todas las barras sumadas?`,
    largest: () => `¿Qué categoría tiene más?`,
    difference: (larger: string, smaller: string) => `¿Cuántos más tiene ${larger} que ${smaller}?`,
    readOne: (label: string) => `¿Cuántos muestra la gráfica para ${label}?`,
};

export const barGraphLabelSets: { labels: string[]; sequential: boolean }[] = [
    { labels: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'], sequential: true },
    { labels: ['lun', 'mar', 'mié', 'jue', 'vie', 'sáb', 'dom'], sequential: true },
    { labels: ['Rojo', 'Azul', 'Verde', 'Amarillo', 'Morado', 'Naranja'], sequential: false },
    { labels: ['Pera', 'Ciruela', 'Kiwi', 'Higo', 'Mango', 'Uva'], sequential: false },
    { labels: ['Golf', 'Ajedrez', 'Atletismo', 'Natación', 'Tenis', 'Patinaje'], sequential: false },
];
